import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Itemcategoryskltn = (props) => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14, 15, 16, 17, 18, 19, 20])

    return (
        <>
            {arry.slice(0, 12).map((info, index) =>
                <div className="item-category skltn" >
                    <div className="pic">
                        <Skeleton animation="wave" variant="rect" width={100 + '%'} height={100 + '%'} />
                    </div>
                </div>
            )}
        </>
    );
}

export default Itemcategoryskltn;